export default "__VITE_ASSET__HMQJbnX5__"